import { DetailsDto } from "@/apis/clients";
import { Popover, Transition } from "@headlessui/react";
import React, { Fragment, useCallback, useEffect, useState } from "react";
import { format } from "@/utils/date";

const dateFormat = "yyyy/MM/dd";

const Menu = ({ menus }: { menus: DetailsDto[] }) => {
  const [menuOther, setMenuOther] = useState<string[]>([]);

  const getTimeMenu = useCallback((start: string, end: string) => {
    const date = format(new Date(start), dateFormat);
    const timeStart = format(new Date(start), "HH:mm");
    const timeEnd = format(new Date(end), "HH:mm");
    return `${date} ${timeStart}-${timeEnd}`;
  }, []);

  const getDetailMenu = useCallback(
    (menu: DetailsDto) => {
      const time = getTimeMenu(
        menu?.event_start_time ?? null,
        menu?.event_end_time ?? null,
      );
      const number = menu?.maximum_number
        ? `（定員 : ${menu?.maximum_number}名）`
        : "";
      return `${time} ${number}`;
    },
    [getTimeMenu],
  );

  useEffect(() => {
    if (!menus?.length) return;
    const _menuOther: string[] = [];
    menus.forEach((menu, index) => {
      if (index !== 0 && menu?.event_start_time && menu?.event_end_time) {
        const _menu = getDetailMenu(menu);
        _menuOther.push(_menu);
      }
    });
    setMenuOther(_menuOther);
  }, [getDetailMenu, menus]);

  return (
    <>
      <li className="text-[#1A1A1C] text-sm font-normal">
        {getDetailMenu(menus?.[0])}
      </li>
      {menuOther.length > 0 && (
        <li>
          <Popover as="div" className="relative">
            <Popover.Button>
              <span className="text-[#47BDAB] font-bold text-sm">他日程</span>
            </Popover.Button>
            <Transition
              as={Fragment}
              enter="transition ease-out duration-200"
              enterFrom="opacity-0 translate-y-1"
              enterTo="opacity-100 translate-y-0"
              leave="transition ease-in duration-150"
              leaveFrom="opacity-100 translate-y-0"
              leaveTo="opacity-0 translate-y-1"
            >
              <Popover.Panel className="absolute left-0 z-10 mt-3 w-max max-w-xs px-4 sm:px-0 md:max-w-3xl">
                <div className="overflow-hidden rounded-lg shadow-lg ring-1 ring-black/5">
                  <div className="py-[5px] px-4 bg-white font-bold text-sm w-full border-b-[1px]">
                    イベント・セミナー日程
                  </div>
                  <div className="relative gap-8 bg-white px-4 py-3 max-h-40 overflow-y-auto">
                    {menuOther.map((item, index) => (
                      <div
                        key={index}
                        className="text-xs leading-[22px] text-black"
                      >
                        {item}
                      </div>
                    ))}
                  </div>
                </div>
              </Popover.Panel>
            </Transition>
          </Popover>
        </li>
      )}
    </>
  );
};

export default Menu;
